import React from 'react';

import Page from 'components/page/Page';
import RequestActivationEmailForm from '../components/RequestActivationEmailForm';
import { t } from 'utils/language';
import AccessContainer from '../components/access-container/AccessContainer';
import AccessContainerHeader from '../components/access-container/access-container-header/AccessContainerHeader';

const RequestActivationEmailPage = () => (
  <Page
    documentTitle={t('access_activation_page')}
  >
    <AccessContainer type="request-activation">
      <AccessContainerHeader title={t('request_activation_email_header')} />
      <RequestActivationEmailForm />
    </AccessContainer>
  </Page>
);

export default RequestActivationEmailPage;
